import React, { useRef, useEffect, useState } from "react";
import { Box, Modal, Typography } from "@mui/material";
import {
  CancelIcon,
  Coinbase,
  HashPack,
  MagicLink,
  Metamask,
} from "../../../shared/icons";
import styled from "styled-components";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  connectCoinbaseWallet,
  connectHashPack,
  connectMagicLink,
  connectMetaMaskWallet,
} from "../../../utils/walletUtils";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { userLogin } from "../../../slices/connectWallet/connectWalletThunks";
import { clearUserData, setUserData } from "../../../slices/auth/authSlice";
import { showToast } from "../../../slices/global/ToastSlice";
import { useNavigate } from "react-router-dom";
import LoaderToast from "../../LoaderToast.tsx";
import { WalletButton as WalletBtn } from '@rainbow-me/rainbowkit';
import { QueryClient } from '@tanstack/react-query';
import '@rainbow-me/rainbowkit/styles.css';
import { cookieStorage,useDisconnect, useAccount } from 'wagmi';
import { screenSizes } from "../../../styles/theme";

import { useWallet } from "../../../utils/WalletContext";


const WalletButton = styled.button<{ active?: boolean }>`
  border: 2px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  color: #ffffff;
  outline: none;
  font-size: 18px;
  font-weight: 600;
  width: 280px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  cursor: pointer;
  margin-bottom: 16px;
  background-color: ${({ active }) =>
    active ? "rgba(255, 255, 255, 0.2)" : "transparent"};
`;

const EmailField = styled.input`
  margin-top: 24px;
  @media (max-width: ${screenSizes.L}px) {
    margin-top: 10px;
  }
  width: 100%;
  padding: 12px 24px;
  background-color: white;
  border-radius: 80px;
  outline: none;
  border: 1px solid rgba(9, 28, 0, 0.1);
`;

const SubmitButton = styled.button`
  margin-top: 24px;
  width: 100%;
  background-color: #ff9d59;
  padding: 12px 24px;
  border-radius: 80px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  @media (max-width: ${screenSizes.L}px) {
    font-size: 16px;
    margin-top: 10px;
  }
`;

const Error = styled.div`
  margin-top: 5px;
  margin-left: 5px;
  font-size: 14px;
  font-weight: 600;
  color: #d91f27;
`;

interface Props {
  open: boolean;
  handleClose: () => void;
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "800px",
  height: "auto",
  maxHeight: "90vh",
  bgcolor: "#091C00",
  border: "2px solid #091C00",
  boxShadow: 24,
  padding: "20px",
  overflowY: "auto"
};

const WalletsModal: React.FC<Props> = ({ open, handleClose }) => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const emailRef = useRef<HTMLInputElement>(null);
  const [activeTab, setActiveTab] = useState("Magiclink");
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [errorLink, setErrorLink] = useState<string | null>(null);
  const { disconnect } = useDisconnect();
  const { isConnected } = useAccount();

  const [scanned, setScanned] = useState(false);

  const { dAppConnector } = useWallet();


  const initialValues = { email: "" };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  useEffect(() => {
    let walletAuthType = localStorage.getItem('walletAuthType');
    console.log('walletAuthType',walletAuthType);
    console.log('isConnected',isConnected);
    console.log('scanned',scanned);
    if (walletAuthType == null && isConnected && !scanned && activeTab == "Metamask") {
      console.log("User scanned the QR code and connected Metamask");
      setScanned(true);
      
        handleConnectQR();
  
    }else if (walletAuthType == null && isConnected && activeTab == "Coinbase") {
      console.log("User scanned the QR code and connected Coinbase");

        handleConnectQR();

    }
  }, [isConnected]);


  const handleConnectQR = async () => {
    console.log('handleConnect');
    try {
      const storedData:any = cookieStorage.getItem("wagmi.store");
      if (!storedData) {
        console.log("Wallet connection data not found in cookies.");
      }
      const cookiesData = JSON.parse(storedData);
      const walletAddress = cookiesData.state.connections.value[0][1]?.accounts?.[0] || "";
      const connector = cookiesData.state.connections.value[0][1]?.connector?.name || "";

      const networkId = cookiesData.state.chainId || "";
      
      console.log('activeTab',activeTab);
      console.log('connector',connector);
      if(connector == 'MetaMask'){
        await localStorage.setItem("walletAuthType", "MetaMask");
      }else{
        await localStorage.setItem("walletAuthType", "Coinbase");
      }

      

      console.log("Connected Wallet:", walletAddress, "Network ID:", networkId);
  
      await handleUserLogin(walletAddress, networkId);
    } catch (error) {
        console.error("Wallet connection failed:", error);
    }
  }; 

  const handleSubmit = (values: { email: string }) => {
    console.log("Form Submitted:", values);
    setIsFormSubmit(true);
    setToastOpen(true);
    connectMagicLink(values.email)
      .then((res) => {
        if (!res) {
          // If the result is undefined, do not proceed
          console.log("MagicLink connection canceled or failed.");
          setErrorMessage("Magiclink connection canceled.");
          setErrorLink("Click here to try again");
          return;
        }
        localStorage.setItem('walletAuthType', 'Magiclink');
        console.log("magic res", res);
        handleUserLogin(
          res?.userMetadata?.publicAddress || "",
          res?.networkId || ""
        );
      })
      .catch((err) => {
        console.error("Error during wallet connection:", err);
        if (err.message === "User rejected the connection") {
          setErrorMessage("Magiclink connection rejected by user.");
        } else {
          setErrorMessage("Magiclink connection failed.");
        }
        setErrorLink("Click here to try again");
      })
      .finally(() => setToastOpen(false));
  };

  const handleUserLogin = async (
    walletAccAddress: string,
    networkId: string
  ) => {
    dispatch(userLogin({ walletAddress: walletAccAddress, networkId }))
      .then((res: any) => {
        if (res?.error) {
          console.log(res?.error);
        }
        console.log("login", res?.payload?.data?.data);
        const data = res?.payload?.data?.data;
        const address = data?.user?.walletAddress || walletAccAddress;

        if (data?.token) {
          dispatch(setUserData(data));
          navigate(`/dashboard/${address}`);
        }
      })
      .catch((err) => {
        dispatch(
          showToast({
            message: err.message || "Something went wrong!",
            severity: "error",
          })
        );
      })
      .finally(() => {});
  };

  const ConnectWallet = (walletType: string) => {
    setErrorMessage(null);
    setErrorLink(null);
    setActiveTab(walletType);
    if (walletType === "Hashpack") {
      setToastOpen(true);
      setTimeout(() => {
        onClose();
        setToastOpen(false);
      }, 1000);

      hashPackLogin(dAppConnector)
        .then((res: any) => {
          if (!res) {
            // If the result is undefined, do not proceed
            console.log("Hashpack connection canceled or failed.");
            return;
          }
          console.log("hashpack res", res);
          localStorage.setItem('walletAuthType', 'Hashpack');
          handleUserLogin(res?.walletAddress || "", res?.networkId || "");
        })
        .catch((err) => {
          console.error("Error during wallet connection:", err);
        })
        .finally(() => setToastOpen(false));
    }
    if (walletType === "Remove Wallet") {
      dispatch(clearUserData());
      navigate("/");
    }
  };

  const onClose = () => {
    setActiveTab("Magiclink");
    setErrorMessage("");
    setErrorLink("");
    setIsFormSubmit(false);
    handleClose();
  };

const queryClient = new QueryClient();

const hashPackLogin = async(dAppConnector:any) => {
  console.log('hashPackLogin');
  const session = await dAppConnector.openModal()
  const sessionRes = handleNewSession(session);
  return sessionRes;

}

// Session handling function
const handleNewSession = async(session:any) => {
  console.log('handleNewSession', session);
  const sessionAccount = session.namespaces?.hedera?.accounts?.[0]
  const sessionParts = sessionAccount?.split(':')
  const accountId = sessionParts.pop()
  const network = sessionParts.pop()

  if (!accountId) {
    return null
  } else {
    localStorage.setItem('hederaAccountId', accountId)
    localStorage.setItem('hederaNetwork', network)
    console.log('sessionAccount is', accountId, network)
    const hashpackData = {
      walletAddress: accountId,
      networkId: network
    }
    return hashpackData;
  }
}
const handleDisconnect = () => {
  console.log("User rejected connection or disconnected. Clearing storage...");
  cookieStorage.removeItem('wagmi.store');
  localStorage.removeItem('wagmi.wallet');
  sessionStorage.removeItem('walletConnect');
  queryClient.clear();
  disconnect();
};

const walletComponents: Record<string, React.ElementType> = {
  Hashpack: HashPack,
  Magiclink: MagicLink,
};

const isMetamaskOrCoinbase = activeTab === "Metamask" || activeTab === "Coinbase";

  return (
    <>
      <LoaderToast
        open={toastOpen}
        message={"Connecting your wallet...."}
        loading={true}
        onClose={() => setToastOpen(false)}
      />
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              textAlign: "right",
              cursor: "pointer",
            }}
            onClick={onClose}
          >
            <CancelIcon />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: "20px", sm: "40px" },
              mt: "20px",
            }}
          >
            {/* wallets */}
            <Box
            sx={{
              pl: { xs: "0", sm: "0", md:"40px" },
              margin: {xs: "auto"}
            }}
            >
              <WalletButton
                onClick={() => ConnectWallet("Magiclink")}
                active={activeTab === "Magiclink"}
              >
                <MagicLink />
                Magic Link
              </WalletButton>
              <WalletButton
                onClick={() => ConnectWallet("Metamask")}
                active={activeTab === "Metamask"}
              >
                <Metamask />
                Metamask
              </WalletButton>
              <WalletButton
                onClick={() => ConnectWallet("Coinbase")}
                active={activeTab === "Coinbase"}
              >
                <Coinbase />
                Coinbase
              </WalletButton>
              <WalletButton
                onClick={() => ConnectWallet("Hashpack")}
                active={activeTab === "Hashpack"}
              >
                <HashPack />
                Hashpack
              </WalletButton>
            </Box>

            {activeTab === "Magiclink" && !isFormSubmit ? (
              <Box
                sx={{
                  flex: 1,
                  borderLeft: { sm:'transparent', md: "1px solid rgba(255, 255, 255, 0.2)"},
                  padding: {md: "0 40px", sm:'0 15px', xs:'0 15px'},
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "16px", sm: "20px" },
                    fontWeight: 500,
                    color: "#FFFFFF",
                  }}
                >
                  Sign In
                </Typography>
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {() => (
                    <Form>
                      <Field
                        name="email"
                        innerRef={emailRef}
                        as={EmailField}
                        placeholder="Enter your email address"
                      />
                      <ErrorMessage name="email" component={Error} />

                      <SubmitButton type="submit">Continue</SubmitButton>
                    </Form>
                  )}
                </Formik>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  borderLeft: { sm:'transparent', md: "1px solid rgba(255, 255, 255, 0.2)"},
                  paddingLeft: "40px",
                  paddingRight: "40px",
                  width: "100%",
                  justifyContent:'center'
                }}
              >
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 500,
                    color: "#FFFFFF",
                  }}
                  mb={"20px"}
                >
                  {
                    activeTab === "Hashpack"
                    ? "Hashpack"
                    : activeTab === "Magiclink"
                    ? "Magiclink"
                    : ""}
                </Typography>
                
                {!isMetamaskOrCoinbase && walletComponents[activeTab] && (
                  React.createElement(walletComponents[activeTab], {
                    style: {
                      height: "80px",
                      width: "80px",
                      marginBottom: "20px",
                    },
                  })
                )}

                {!isMetamaskOrCoinbase &&
                  (errorMessage ? (
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontWeight: 400,
                        color: "#FF9D59",
                        cursor: "pointer",
                        textAlign: "center",
                      }}
                      mb={"20px"}
                    >
                      {errorMessage}
                    </Typography>
                  ) : (
                    <>
                      <Typography
                        sx={{
                          fontSize: "20px",
                          fontWeight: 400,
                          color: "#FFFFFF",
                        }}
                      >
                        Awaiting Confirmation
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "rgba(255, 255, 255, 0.6)",
                          textAlign: "center",
                        }}
                        mb={"20px"}
                      >
                        Accept the connection request in {activeTab}
                      </Typography>
                    </>
                  ))}

                {!isMetamaskOrCoinbase && (
                  <Box
                    sx={{
                      width: "100%",
                      height: "1px",
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                    }}
                    mb={"20px"}
                  />
                )}

                {!isMetamaskOrCoinbase && errorLink && (
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#FF9D59",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (activeTab === "Magiclink") {
                        setIsFormSubmit(false);
                      } else {
                        window.open(errorLink, "_blank");
                      }
                    }}
                  >
                    {activeTab === "Magiclink"
                      ? errorLink
                      : `Click here to install the ${activeTab} extension.`}
                  </Typography>
                )}

                {isMetamaskOrCoinbase && (
                  <>
                    {activeTab === "Metamask" ? <Metamask style={{marginBottom: "20px", height:'100px', width: "100px"}}/> : <Coinbase style={{marginBottom: "20px", height:'100px', width: "100px"}}/>}
                    
                    {isConnected ? (
                      <SubmitButton onClick={handleDisconnect}>
                        Disconnect Wallet
                      </SubmitButton>
                      )
                      :
                      (
                      <WalletBtn.Custom 
                      wallet={activeTab.toLowerCase()}
                      >
                        {({ ready, connect }) => {
                          const handleConnect = async () => {
                            console.log('handleConnect', activeTab.toLowerCase());
                            await connect();
                           // await handleConnectQR()
                          };                          
                          return (
                            <SubmitButton
                              type="button"
                              disabled={!ready}
                              onClick={handleConnect}
                            >
                              Connect {activeTab}
                            </SubmitButton>
                          );
                        }}
                      </WalletBtn.Custom>
                    )}
                  </>
                )}
              </Box>
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default WalletsModal;
